export { default as VictoryAnimation } from "./victory-animation/victory-animation";
export { default as VictoryContainer } from "./victory-container/victory-container";
export { default as VictoryLabel } from "./victory-label/victory-label";
export { default as VictoryTransition } from "./victory-transition/victory-transition";
export { default as VictorySharedEvents } from "./victory-shared-events/victory-shared-events";
export { default as VictoryClipContainer } from "./victory-clip-container/victory-clip-container";
export { default as VictoryTheme } from "./victory-theme/victory-theme";
export { default as VictoryLegend } from "./victory-legend/victory-legend";
export { default as VictoryTooltip } from "./victory-tooltip/victory-tooltip";
export { default as VictoryPortal } from "./victory-portal/victory-portal";
export { default as Portal } from "./victory-portal/portal";
export { default as Arc } from "./victory-primitives/arc";
export { default as Area } from "./victory-primitives/area";
export { default as Bar } from "./victory-primitives/bar";
export { default as Border, default as Box } from "./victory-primitives/border";
export { default as Candle } from "./victory-primitives/candle";
export { default as ClipPath } from "./victory-primitives/clip-path";
export { default as Curve } from "./victory-primitives/curve";
export { default as ErrorBar } from "./victory-primitives/error-bar";
export { default as Axis, default as Grid } from "./victory-primitives/axis";
export { default as Point } from "./victory-primitives/point";
export { default as Slice } from "./victory-primitives/slice";
export { default as Voronoi } from "./victory-primitives/voronoi";
export { default as Flyout } from "./victory-primitives/flyout";
export { default as Whisker } from "./victory-primitives/whisker";
export { default as addEvents } from "./victory-util/add-events";
export { default as Collection } from "./victory-util/collection";
export { default as Data } from "./victory-util/data";
export { default as DefaultTransitions } from "./victory-util/default-transitions";
export { default as Domain } from "./victory-util/domain";
export { default as Events } from "./victory-util/events";
export { default as Helpers } from "./victory-util/helpers";
export { default as Immutable } from "./victory-util/immutable";
export { default as LabelHelpers } from "./victory-util/label-helpers";
export { default as Log } from "./victory-util/log";
export { default as PropTypes } from "./victory-util/prop-types";
export { default as Scale } from "./victory-util/scale";
export { default as Selection } from "./victory-util/selection";
export { default as Style } from "./victory-util/style";
export { default as TextSize } from "./victory-util/textsize";
export { default as Timer } from "./victory-util/timer";
export { default as Transitions } from "./victory-util/transitions";
export { default as Rect } from "./victory-primitives/rect";
export { default as Path } from "./victory-primitives/path";
export { default as Line } from "./victory-primitives/line";
export { default as Circle } from "./victory-primitives/circle";
export { default as TSpan } from "./victory-primitives/tspan";
export { default as Text } from "./victory-primitives/text";


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/index.js
// module id = 22
// module chunks = 0